import classNames from 'classnames';

const HoverArrow = (): JSX.Element => (
  <g fillRule="evenodd" className="hover-arrow-icon">
    <path
      className={classNames('hover-arrow-icon--stem', 'w-full')}
      d="M0,0.6C0,0.3,0.2,0,0.5,0h6.3H8c0.2,0.1,0.3,0.5,0.3,0.6S8.3,1,8,1.2H6.8H0.5C0.2,1.2,0,0.9,0,0.6z"
    ></path>
    <path
      className={classNames('hover-arrow-icon--tip', 'w-full')}
      d="M0.767476 7.81586C0.5378 7.577 0.545248 7.19718 0.784111 6.9675L3.93431 4L0.784111 1.0325C0.545248 0.802823 0.5378 0.422997 0.767476 0.184134C0.997152 -0.0547285 1.37698 -0.0621767 1.61584 0.167499L5.21584 3.5675C5.33349 3.68062 5.39998 3.83679 5.39998 4C5.39998 4.16321 5.33349 4.31938 5.21584 4.4325L1.61584 7.8325C1.37698 8.06218 0.997153 8.05473 0.767476 7.81586Z"
    ></path>
  </g>
);

export default HoverArrow;
